<template>
  <select v-model="period" name="period">
    <option v-for="item in list" :key="item" :value="item">{{ periodName(item) }}</option>
    <option value="all">Все</option>
  </select>
</template>

<script>
export default {
  props: {
    id: String,
    defaultSet: {
      type: String,
      default: "all"
    },
    list: Array
  },

  data() {
    return {
      period: this.defaultSet
    };
  },

  methods: {
    periodName(item) {
      let name;

      switch (item) {
        case "startyear":
          name = "С начала года";
          break;
        case "today":
          name = "Сегодня";
          break;
        case "week":
          name = "Неделя";
          break;
        case "month":
          name = "Месяц";
          break;
        case "quarter":
          name = "Квартал";
          break;
        case "year":
          name = "Год";
          break;
        default:
          break;
      }

      return name;
    }
  },

  watch: {
    period: function() {
      const { period, id } = this;
      const fromEl = $(".js-datepicker-from-" + id);
      const toEl = $(".js-datepicker-to-" + id);
      const datepickerFromData = fromEl.datepicker().data("datepicker");
      const datepickerToData = toEl.datepicker().data("datepicker");
      let dateFrom = new Date();
      let dateTo = new Date();

      switch (period) {
        case "startyear":
          dateFrom = new Date(new Date().getFullYear(), 0, 1);
          dateTo = null;
          break;
        case "all":
          dateFrom = null;
          dateTo = null;
          break;
        case "today":
          dateFrom = dateTo;
          break;
        case "week":
          dateFrom.setDate(dateTo.getDate() - 7);
          break;
        case "month":
          dateFrom.setMonth(dateTo.getMonth() - 1);
          break;
        case "quarter":
          dateFrom.setMonth(dateTo.getMonth() - 3);
          break;
        case "year":
          dateFrom.setFullYear(dateTo.getFullYear() - 1);
          break;
      }

      if (dateFrom) {
        datepickerFromData.selectDate(dateFrom);
        datepickerToData.update("minDate", dateFrom);
      } else {
        datepickerFromData.clear();
      }

      if (dateTo) {
        datepickerToData.selectDate(dateTo);
        datepickerFromData.update("maxDate", dateTo);
      } else {
        datepickerToData.clear();
      }
    }
  }
};
</script>
